import { createSelector } from 'reselect';
import type { RootState } from '../../configuration/setup/store';

export const selectApp = (state: RootState) => state.app;
export const selectSessionExpiredAcknowledged = createSelector(selectApp, state => state.sessionExpiredAcknowledged);
export const selectPageDisplayed = createSelector(selectApp, state => state.pageDisplayed);
export const selectLegalDisclaimerDisplay = createSelector(selectApp, state => state.legalDisclaimerDisplay);
export const selectTourHandlingId = createSelector(selectApp, state => state.tourHandlingId);
export const selectPastTourFlag = createSelector(selectApp, state => state.pastTourFlag);
export const selectDraftExistsFlag = createSelector(selectApp, state => state.draftExistsFlag);
